//for IE browser
import 'babel-polyfill'
import 'event-source-polyfill'
import 'es6-promise/auto';
import swal from 'sweetalert'
window.Vue = require('vue');
//vue-js-modal
import VModal from 'vue-js-modal'
Vue.use(VModal);
//vue-cookie
import VueCookies from 'vue-cookies'
Vue.use(VueCookies);// set global cookie
VueCookies.config('7d');
//lodash
window._ = require('lodash');
//jquery
try {
    window.$ = window.jQuery = require('jquery');
} catch (e) {}
//ajax utility, we don't use csrf token right now...
window.axios = require('axios');
window.axios.defaults.headers.get['Pragma'] = 'no-cache';
// window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
// let token = document.head.querySelector('meta[name="csrf-token"]');
// if (token) {
//     window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
// } else {
//     console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
// }
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.interceptors.response.use(null, function(error) {
    if(error.response.status === 500){
        swal('알림','서버 오류 : 1688-2447로 문의 바랍니다.','error');
    }else if(error.response.status === 401){
        swal('잘못된 접근입니다.\n 메인페이지로 돌아갑니다.',{
            buttons : false,
            timer : 3000
        }).then( () =>{
            location.href = `/`
        })
    }else if(error.response.status === 419){
        swal('알림','접근 권한이 없습니다.','error');
    }else{
        swal('알림','오류','error');
    }
    return Promise.reject(error);
});

// import VueRouter  from 'vue-router';
// Vue.use(VueRouter);
// freaking IE9 -> diable vue router 
window.getUrlParam = function(name){
	name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
	var regexS = "[\\?&]"+name+"=([^&#]*)";
	var regex = new RegExp(regexS);
	var results = regex.exec(window.location.href);
	if (results == null) {
		return '';
	} else {
		return results[1];
	}
}